import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import "react-toastify/dist/ReactToastify.css";
import { MaterialReactTable } from 'material-react-table';
import PropTypes from 'prop-types';

// import { loader_image } from "../_components/Imagepath";
import Select from 'react-select';
import $ from "jquery";
import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';
const Orders = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  // const [statusOptions, setStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});
  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);
  const [dataPending, setDataPending] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [dataInproduction, setDataInproduction] = useState([]);
  const [dataCancelled, setDataCancelled] = useState([]);
  const [dataProduced, setDataProduced] = useState([]);
  const [dataConfirmed, setDataConfirmed] = useState([]);
  const [dataShipped, setDataShipped] = useState([]);
  const [dataDelivered, setDataDelivered] = useState([]);
  let season_id = localStorage.getItem("season_id");
  // const [isLoading, setIsLoading] = useState(false);

  const statusOptions = [
    {
      "id": 1,
      "title": "PENDING",
      "type": 1,
      "color": "black",
      "bg_color": "yellow",

    },
    {
      "id": 3,
      "title": "CONFIRMED",
      "type": 1,
      "color": "white",
      "bg_color": "#24bc06",

    },
    {
      "id": 5,
      "title": "CANCELLED",
      "type": 1,
      "color": "white",
      "bg_color": "#525252",

    }
  ]
  const backendErrors = '';
  const options = [
    { value: '1', label: "PENDING" },
    { value: '2', label: "IN-PRODUCTION" },
    { value: '3', label: "CONFIRMED" },
    { value: '4', label: "SHIPPED" },
    { value: '5', label: "CANCELLED" },
    { value: '6', label: "PRODUCED" },
    { value: '7', label: "DELIVERED" },
  ];


  const handleSelectChange = (selectedOptions) => {
    setFormData({ ...formData, order_stats: selectedOptions ? selectedOptions.map(option => option.value) : [] });
  };
  const handleSelectChangeCustomer = (selectedOption) => {
    setFormData({ ...formData, customer: selectedOption ? selectedOption.value : null });
  };


  const [formData, setFormData] = useState({
    customer: '',
    season_id: season_id,
    order_stats: [],
    start_eta_week: '',
    end_eta_week: '',

  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleSubmit = (e) => {
    e.preventDefault();


    axios
      .post("/orders/filtered-list", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {


        if (response.data.code === 200) {
          let all_orders = response.data.data.orders;
          let order_pending = [];
          let order_Inproduction = [];
          let order_Confirmed = [];
          let order_Shipped = [];
          let order_Cancelled = [];
          let order_Produced = [];
          let order_Delivered = [];
          all_orders.forEach((order) => {
            switch (order.order_status) {
              case 1:
                order_pending.push(order);
                break;
              case 2:
                order_Inproduction.push(order);
                break;
              case 3:
                order_Confirmed.push(order);
                break;
              case 4:
                order_Shipped.push(order);
                break;
              case 5:
                order_Cancelled.push(order);
                break;
              case 6:
                order_Produced.push(order);
                break;
              case 7:
                order_Delivered.push(order);
                break;

              default:
                break;
            }
          });

          setData(all_orders);
          setDataPending(order_pending);
          setDataInproduction(order_Inproduction);
          setDataConfirmed(order_Confirmed);
          setDataShipped(order_Shipped);
          setDataCancelled(order_Cancelled);
          setDataProduced(order_Produced);
          setDataDelivered(order_Delivered);

          $("#filtered-excel-button").show();

        }
        else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error)
        // actions.setSubmitting(false);
      });

  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };




  const deleteItem = (id) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/orders/delete/${season_id + '-' + id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/orders";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  useEffect(() => {
    setPermission(FindModuleById(6));
    console.log(permission);


    axios.post("/customers/listing", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken } }).
      then((response) => {
        if (response.data.code === 200) {
          let incoterms = response.data.data.customers;
          let customerListing = incoterms.map((cust, index) => ({
            label: cust.company_name,
            value: cust.id,
            key: `types-${index}`,
          }));
          setCustomerList(customerListing);
        }

      })
      .catch((error) => {
        console.log(error);
      });

    axios.post("/orders/listing", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        //setData(response.data.data.orders);
        let all_orders = response.data.data.orders;
        let order_pending = [];
        let order_Inproduction = [];
        let order_Confirmed = [];
        let order_Shipped = [];
        let order_Cancelled = [];
        let order_Produced = [];
        let order_Delivered = [];
        all_orders.forEach((order) => {
          switch (order.order_status) {
            case 1:
              order_pending.push(order);
              break;
            case 2:
              order_Inproduction.push(order);
              break;
            case 3:
              order_Confirmed.push(order);
              break;
            case 4:
              order_Shipped.push(order);
              break;
            case 5:
              order_Cancelled.push(order);
              break;
            case 6:
              order_Produced.push(order);
              break;
            case 7:
              order_Delivered.push(order);
              break;

            default:
              break;
          }
        });
        //setIsLoading(true);

        setData(all_orders);
        setDataPending(order_pending);
        setDataInproduction(order_Inproduction);
        setDataConfirmed(order_Confirmed);
        setDataShipped(order_Shipped);
        setDataCancelled(order_Cancelled);
        setDataProduced(order_Produced);
        setDataDelivered(order_Delivered);
      }).catch((error) => { console.log(error); });



  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };




  const editItem = (item) => {
    window.location.href = "/orders-edit/" + item;
  }
  // const viewItem = (item)=>{
  //   window.location.href = "/orders-view/"+item;
  // }
  const PONumberCell = ({ row }) => {
    return (
      <a href={`/orders-view/${row.original.id}`} className="">
        {row.original.po_number}
      </a>
    );
  };

  // ✅ Define PropTypes
  PONumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        po_number: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const OrderStatusCell = ({ row, statusOptions, changeOrderStatus }) => {

    // console.log("row.original.id");
    // console.log(row.original.id);
    // if(row.original.id == 1 || row.original.id == 3 || row.original.id == 5){

    // }else{

    // }
    return (
      <div className="btn-group custom-table-btn-group">
        <button
          type="button"
          className="btn btn-block dropdown-toggle me-1"
          id={`status-all-${row.original.id}`}
          style={{
            backgroundColor: row.original.status.bg_color,
            color: row.original.status.color,
          }}
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {row.original.status ? row.original.status.title : ''}
        </button>
        <div className="dropdown-menu">
          {statusOptions &&
            statusOptions.map((shipp) => (
              <button
                key={shipp.id}
                className="dropdown-item btn btn-block"
                style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
              >
                {shipp.title}
              </button>
            ))}
        </div>
      </div>
    );
  };

  // ✅ Define PropTypes
  OrderStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        status: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
    statusOptions: PropTypes.array.isRequired,
    changeOrderStatus: PropTypes.func.isRequired,
  };
  const columns = [
    {
      header: 'PO Number',
      accessorFn: (row) => `${row.po_number}`,
      Cell: PONumberCell, // ✅ Use the separate component
    },
    {
      header: 'Customer',
      accessorFn: (row) => `${row.customer ? row.customer.company_name : ''}`,
    },
    {
      header: 'Order Progress',
      accessorKey: 'order_progress',
      accessorFn: (row) => {
        const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
        const production_outputs_total = row.production_outputs.length;
        return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
      },
      // Cell: ({ renderedCellValue }) => <div>{renderedCellValue.toFixed(2) + '%'}</div>,
      sortDescFirst: true,
    },
    {
      header: 'Order Status',
      accessorFn: (row) => `${row.status ? row.status.title : ''}`,
      Cell: (props) => <OrderStatusCell {...props} statusOptions={statusOptions} changeOrderStatus={changeOrderStatus} />,
    },
    {
      header: 'Shipping Address',
      accessorFn: (row) => `${row.ship_address ? row.ship_address.name : ''}`,
    },
    {
      accessorKey: 'eta_week',
      header: 'ETA Week',
    },
    {
      accessorKey: 'remarks',
      header: 'Note / Remark',
    },

    {
      header: 'Shipping method',
      accessorFn: (row) => `${row.ship_method ? row.ship_method.title : ''}`,
    },
    {
      header: 'Number Of Pallets',
      accessorFn: (row) => {
        const totalcount = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
        return totalcount;
      },
      cell: ({ getValue }) => {
        return <span>{getValue()}</span>;
      }
    },
    {
      accessorKey: 'exportator_number',
      header: 'Exportator Number',
    },
    {
      header: 'Production Location',
      accessorFn: (row) => `${row.order_location ? row.order_location.title : ''}`,
    },
    {
      header: 'Created By',
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
    },
    {
      header: 'Updated At',
      accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
    },
  ];




  const columnsPending =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress',
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        // Cell: ({ renderedCellValue }) => <div>{renderedCellValue.toFixed(2) + '%'}</div>,
        sortDescFirst: true,
      },

      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status ? row.status.title : ''}`,
        Cell: (props) => <OrderStatusCell {...props} statusOptions={statusOptions} changeOrderStatus={changeOrderStatus} />,
      },

      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'ETA Week',
      },
      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        accessorKey: 'exportator_number', //normal accessorKey
        header: 'Exportator Number',
      },
      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },
      {
        header: 'Number Of Pallets',
        accessorFn: (row) => {
          const totalcount = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          return totalcount;
        },
        cell: ({ getValue }) => {
          return <span>{getValue()}</span>;
        }
      },

      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
      {
        header: 'Updated At',
        accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
      },
    ];


  const columnsConfirmed =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
      
        sortDescFirst: true, // Set default sorting order to descending
      },
    
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusCell, // ✅ Use the extracted component
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'ETA Week',
      },
      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        accessorKey: 'exportator_number', //normal accessorKey
        header: 'Exportator Number',
      },

      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },

      {
        header: 'Number Of Pallets',
        accessorFn: (row) => {
          const totalcount = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          return totalcount;
        },
        cell: ({ getValue }) => {
          return <span>{getValue()}</span>;
        }
      },
      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },

      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
      {
        header: 'Updated At',
        accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
      },
    ];

  const columnsInproduction =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        // Cell: ({ renderedCellValue }) => {
        //   return <div>{renderedCellValue.toFixed(2) + '%'}</div>;
        // },
        sortDescFirst: true, // Set default sorting order to descending
      },
      // {
      //   header: 'Order Status',
      //   accessorFn: (row) => `${(row.status)?row.status.title:""} `,
      //   Cell: ({ cell, row }) => (
      //     <button type="button" className="btn btn-block  me-1" id={`status-confirmed-${row.original.id}`}  style={{backgroundColor:row.original.status.bg_color, color: row.original.status.color}}  >{(row.original.status)?row.original.status.title:""} </button>


      //   ),
      // },
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusCell, // ✅ Use the extracted component
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'ETA Week',
      },
      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        accessorKey: 'exportator_number', //normal accessorKey
        header: 'Exportator Number',
      },
      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },
      {
        header: 'Number Of Pallets',
        accessorFn: (row) => {
          const totalcount = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          return totalcount;
        },
        cell: ({ getValue }) => {
          return <span>{getValue()}</span>;
        }
      },

      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
      {
        header: 'Updated At',
        accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
      },
    ];


  const columnsShipped =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        // Cell: ({ renderedCellValue }) => {
        //   return <div>{renderedCellValue.toFixed(2) + '%'}</div>;
        // },
        sortDescFirst: true, // Set default sorting order to descending
      },
      // {
      //   header: 'Order Status',
      //   accessorFn: (row) => `${(row.status)?row.status.title:""} `,
      //   Cell: ({ cell, row }) => (
      //     <button type="button" className="btn btn-block  me-1" id={`status-confirmed-${row.original.id}`}  style={{backgroundColor:row.original.status.bg_color, color: row.original.status.color}}  >{(row.original.status)?row.original.status.title:""} </button>


      //   ),
      // },
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusCell, // ✅ Use the extracted component
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'ETA Week',
      },
      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        accessorKey: 'exportator_number', //normal accessorKey
        header: 'Exportator Number',
      },

      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },
      {
        header: 'Number Of Pallets',
        accessorFn: (row) => {
          const totalcount = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          return totalcount;
        },
        cell: ({ getValue }) => {
          return <span>{getValue()}</span>;
        }
      },

      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
      {
        header: 'Updated At',
        accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
      },
    ];


  const columnsCancelled =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        // Cell: ({ renderedCellValue }) => {
        //   return <div>{renderedCellValue.toFixed(2) + '%'}</div>;
        // },
        sortDescFirst: true, // Set default sorting order to descending
      },
      // {
      //   header: 'Order Status',
      //   accessorFn: (row) => `${(row.status)?row.status.title:""} `,
      //   Cell: ({ cell, row }) => (
      //     <button type="button" className="btn btn-block  me-1" id={`status-confirmed-${row.original.id}`}  style={{backgroundColor:row.original.status.bg_color, color: row.original.status.color}}  >{(row.original.status)?row.original.status.title:""} </button>


      //   ),
      // },
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusCell, // ✅ Use the extracted component
      },

      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'ETA Week',
      },
      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        accessorKey: 'exportator_number', //normal accessorKey
        header: 'Exportator Number',
      },

      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },
      {
        header: 'Number Of Pallets',
        accessorFn: (row) => {
          const totalcount = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          return totalcount;
        },
        cell: ({ getValue }) => {
          return <span>{getValue()}</span>;
        }
      },

      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
      {
        header: 'Updated At',
        accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
      },
    ];


  const columnsProduced =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },

      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        // Cell: ({ renderedCellValue }) => {
        //   return <div>{renderedCellValue.toFixed(2) + '%'}</div>;
        // },
        sortDescFirst: true, // Set default sorting order to descending
      },
      // {
      //   header: 'Order Status',
      //   accessorFn: (row) => `${(row.status)?row.status.title:""} `,
      //   Cell: ({ cell, row }) => (
      //     <button type="button" className="btn btn-block  me-1" id={`status-confirmed-${row.original.id}`}  style={{backgroundColor:row.original.status.bg_color, color: row.original.status.color}}  >{(row.original.status)?row.original.status.title:""} </button>


      //   ),
      // },
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusCell, // ✅ Use the extracted component
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'ETA Week',
      },
      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        accessorKey: 'exportator_number', //normal accessorKey
        header: 'Exportator Number',
      },

      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },
      {
        header: 'Number Of Pallets',
        accessorFn: (row) => {
          const totalcount = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          return totalcount;
        },
        cell: ({ getValue }) => {
          return <span>{getValue()}</span>;
        }
      },

      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
      {
        header: 'Updated At',
        accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
      },
    ];

  const columnsDelivered =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        // Cell: ({ renderedCellValue }) => {
        //   return <div>{renderedCellValue.toFixed(2) + '%'}</div>;
        // },
        sortDescFirst: true, // Set default sorting order to descending
      },
      // {
      //   header: 'Order Status',
      //   accessorFn: (row) => `${(row.status)?row.status.title:""} `,
      //   Cell: ({ cell, row }) => (
      //     <button type="button" className="btn btn-block  me-1" id={`status-confirmed-${row.original.id}`}  style={{backgroundColor:row.original.status.bg_color, color: row.original.status.color}}  >{(row.original.status)?row.original.status.title:""} </button>


      //   ),
      // },
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusCell, // ✅ Use the extracted component
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'ETA Week',
      },
      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        accessorKey: 'exportator_number', //normal accessorKey
        header: 'Exportator Number',
      },

      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },
      {
        header: 'Number Of Pallets',
        accessorFn: (row) => {
          const totalcount = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          return totalcount;
        },
        cell: ({ getValue }) => {
          return <span>{getValue()}</span>;
        }
      },


      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
      {
        header: 'Updated At',
        accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
      },
    ];

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);

    // Get the components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Determine AM/PM
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
  };

  const changeOrderStatus = (user_id, status, type) => {

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/orders/change-status/${season_id + '-' + user_id}/${status}`, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
          .then((response) => {
            console.log(response.data.data.order_status);
            if (response.data.code === 200) {
              $("#status-" + type + "-" + user_id).text(response.data.data.order_status.title);
              $("#status-" + type + "-" + user_id).css('background-color', response.data.data.order_status.bg_color);
              $("#status-" + type + "-" + user_id).css('color', response.data.data.order_status.color);


              axios.post("/orders/listing", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
                .then((response) => {
                  let all_orders = response.data.data.orders;
                  let order_pending = [];
                  let order_Inproduction = [];
                  let order_Confirmed = [];
                  let order_Shipped = [];
                  let order_Cancelled = [];
                  let order_Produced = [];
                  let order_Delivered = [];
                  all_orders.forEach((order) => {
                    switch (order.order_status) {
                      case 1:
                        order_pending.push(order);
                        break;
                      case 2:
                        order_Inproduction.push(order);
                        break;
                      case 3:
                        order_Confirmed.push(order);
                        break;
                      case 4:
                        order_Shipped.push(order);
                        break;
                      case 5:
                        order_Cancelled.push(order);
                        break;
                      case 6:
                        order_Produced.push(order);
                        break;
                      case 7:
                        order_Delivered.push(order);
                        break;

                      default:
                        break;
                    }
                  });

                  setData(all_orders);
                  setDataPending(order_pending);
                  setDataInproduction(order_Inproduction);
                  setDataConfirmed(order_Confirmed);
                  setDataShipped(order_Shipped);
                  setDataCancelled(order_Cancelled);
                  setDataProduced(order_Produced);
                  setDataDelivered(order_Delivered);



                }).catch((error) => { console.log(error); });



              Swal.fire(
                'Success!',
                'Order Status has been changed Successfully.',
                'success'
              );
              // setTimeout(() => {
              //  // window.location.href = "/orders";
              // }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });




  }

  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }

  const downloadExcelFiltered = (e) => {
    console.log(e);
    console.log(formData);
    let order_statss = formData.order_stats;
    let all_status = [];
    order_statss.map((brk, index) => {
      console.log(index);
      all_status.push(brk.value);
    });
    let all_status2 = all_status.toString();
    formData.status = all_status2;
    console.log(formData);

    $("#loader-image3").removeClass('loader-hide2');
    $("#loader-image3").addClass('loader-show2');
    const queryString = objectToQueryString(formData);

    window.open(`${base_url}/orders/listing-excel-open?${queryString}`, '_blank');


  }


  
    useEffect(() => {
      const syncScrollbars = () => {
        const tableContainer = document.querySelector('.production-output-listing .MuiTableContainer-root');
        const topScroll = topScrollRef.current;
        const topScrollContent = topScroll?.querySelector('.top-scroll-content');
  
        if (tableContainer && topScroll && topScrollContent) {
          topScrollContent.style.width = `${tableContainer.scrollWidth}px`;
          
          const handleTopScroll = () => {
            tableContainer.scrollLeft = topScroll.scrollLeft;
          };
          
          const handleTableScroll = () => {
            topScroll.scrollLeft = tableContainer.scrollLeft;
          };
  
          topScroll.addEventListener('scroll', handleTopScroll);
          tableContainer.addEventListener('scroll', handleTableScroll);
  
          return () => {
            topScroll.removeEventListener('scroll', handleTopScroll);
            tableContainer.removeEventListener('scroll', handleTableScroll);
          };
        }
      };
      const timer = setTimeout(syncScrollbars, 100);
      return () => clearTimeout(timer);
    }, [data]);
    // Replace your existing useEffect for sync scrollbars with this:





  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />
      {/* <ToastContainer /> */}

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Orders</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Orders</li>
                </ul>
              </div>
              <div className="col-auto">
                {permission?.add == 1 && (
                  <Link to="/orders-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                )}
                {/* &nbsp;&nbsp;
                  {permission?.list == 1 && (
                  <button
                  className="btn btn-primary"
                  onClick={() => downloadExcel()}
                >
                  <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                </button> 
                )}    */}
              </div>
            </div>
          </div>
          <div id="filter_inputs" className="card filter-card2">
            <div className="card-body p-10">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Customer:</label>

                      <Select

                        options={customerList}
                        name="customer"
                        value={customerList.find(option => option.value === formData.customer) || null}
                        onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Order Status:</label>

                      <Select
                        isMulti
                        options={options}
                        name="order_stats"
                        value={options.filter(option => formData.order_stats?.includes(option.value))}
                        onChange={(selectedOptions) => handleSelectChange(selectedOptions)}
                      />

                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Start ETA Week:</label>
                      <input type="text" name="start_eta_week" placeholder="Enter Start ETA Week" className="form-control" value={formData.start_eta_week} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End ETA Week:</label>
                      <input type="text" name="end_eta_week" placeholder="Enter End ETA Week" className="form-control" value={formData.end_eta_week} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} />
                    </div>
                  </div>



                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/orders" className="btn btn-primary me-1"><i className="fa fa-times"></i></a> &nbsp;&nbsp;

                      <button
                        className="btn btn-primary"
                        id="filtered-excel-button"
                        //style={{display:'none'}}
                        onClick={() => downloadExcelFiltered()}
                      >
                        <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                        {/* <img id="loader-image3" className="loader-image2 loader-hide2" src={loader_image}/> */}
                      </button>



                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>


          <div className="row">
            <div className="col-sm-12">
              {permission?.list == 1 && (
                <section className="comp-section order-listing-page">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card bg-white">

                        <div className="card-body">
                          <ul className="nav nav-tabs nav-tabs-bottom">

                            <li className="nav-item">
                              <a className="nav-link active" href="#all-orders" data-bs-toggle="tab">All Orders ({data.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-pending" data-bs-toggle="tab"> Pending Orders ({dataPending.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-Confirmed" data-bs-toggle="tab"> Confirmed Orders ({dataConfirmed.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-In-production" data-bs-toggle="tab"> In-Production Orders ({dataInproduction.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-Shipped" data-bs-toggle="tab"> Shipped Orders ({dataShipped.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-Cancelled" data-bs-toggle="tab"> Cancelled Orders ({dataCancelled.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-Produced" data-bs-toggle="tab"> Produced Orders ({dataProduced.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-delivered" data-bs-toggle="tab"> Delivered Orders ({dataDelivered.length})</a>
                            </li>
                          </ul>
                          <div className="tab-content">

                            <div className="tab-pane show active" id="all-orders">
                              <div className="row" id="listing-followup-groupby" >
                                <div className="col-sm-12" >
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div
                                          ref={topScrollRef}
                                          className="top-scrollbar"
                                          style={{
                                            overflowX: 'auto',
                                            overflowY: 'hidden',
                                            marginBottom: '10px',
                                            height: '80px'
                                          }}
                                        >
                                        <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                      </div>
                                      <div className="table-responsive production-output-listing" ref={tableContainerRef}>
                                        <MaterialReactTable columns={columns} data={data}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{ pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                       
                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane " id="list-pending">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsPending} data={dataPending}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{ pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                          //sorting: [{ id: 'order_progress', desc: true }],
                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-Confirmed">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsConfirmed} data={dataConfirmed}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{ pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting

                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-In-production">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsInproduction} data={dataInproduction}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{ pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting

                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-Shipped">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsShipped} data={dataShipped}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{ pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting

                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-Cancelled">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsCancelled} data={dataCancelled}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{ pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting

                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-Produced">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsProduced} data={dataProduced}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{ pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting

                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-delivered">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsDelivered} data={dataDelivered}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{ pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting

                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Orders;
